// Note: The first file of a module here, must also register the module

import "./activity-filter.component";
import "./activity-filter-dialog.component";
import "./activity-list.component";
import "./canvass-item.component";
import "./hidden-info.component";
